"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var MenuList_1 = __importDefault(require("@material-ui/core/MenuList"));
var MenuList = function (_a) {
    var children = _a.children, _b = _a.autoFocus, autoFocus = _b === void 0 ? false : _b, _c = _a.autoFocusItem, autoFocusItem = _c === void 0 ? false : _c, _d = _a.disabledItemsFocusable, disabledItemsFocusable = _d === void 0 ? false : _d, _e = _a.disableListWrap, disableListWrap = _e === void 0 ? false : _e, _f = _a.variant, variant = _f === void 0 ? 'selectedMenu' : _f;
    return (react_1.default.createElement(MenuList_1.default, { autoFocus: autoFocus, autoFocusItem: autoFocusItem, disabledItemsFocusable: disabledItemsFocusable, disableListWrap: disableListWrap, variant: variant }, children));
};
exports.default = MenuList;
